var path = 'app/scripts/modules/amazon/src/serverGroup/configure/wizard/capacity/zones.html';
var html = "<div class=\"container-fluid form-horizontal\">\n  <availability-zone-selector command=\"command\"></availability-zone-selector>\n  <az-rebalance-selector command=\"command\"></az-rebalance-selector>\n</div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/amazon/src/serverGroup/configure/wizard/capacity/zones.html
// module id = 1240
// module chunks = 0